/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkAssessmentAwsSyncFields {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkAssessmentAwsSyncFields.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkAssessmentAwsSyncFields>): WellArchitectedFrameworkAssessmentAwsSyncFields {
        let obj = Object.assign(new WellArchitectedFrameworkAssessmentAwsSyncFields(), model);
        WellArchitectedFrameworkAssessmentAwsSyncFields.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkAssessmentAwsSyncFields>): WellArchitectedFrameworkAssessmentAwsSyncFields {
        if (!model) return null;
        return WellArchitectedFrameworkAssessmentAwsSyncFields.newInstance(<WellArchitectedFrameworkAssessmentAwsSyncFields> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkAssessmentAwsSyncFields) {
        if (!obj) return;

        models.WellArchitectedFrameworkAssessmentAwsSyncFields.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkAssessmentAwsSyncFields): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkAssessmentAwsSyncFields.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of cloud account
     */
    cloud_account_id: string;

    /**
     * Name of region
     */
    region: string;

    /**
     * AWS Partner Network(APN) reference ID
     */
    partner_id: string;

}
